<template>
  <ul class="buy-button list-none mb-0 w-full sm:w-auto">
    <template v-if="loggedIn">
      <li class="flex sm:inline-flex items-center gap-1 flex-nowrap justify-end py-1 sm:py-0">
        <span class="px-2 py-3 order-2 sm:order-1 mr-auto ml-1 sm:m-0">
          <DarkModeSwitcher />
        </span>

        <div class="dropdown inline-block relative order-3 sm:order-2">
          <button data-dropdown-toggle="dropdown" class="dropdown-toggle items-center" type="button" ref="dropdownToggle"
            @click="dropdownOpen = !dropdownOpen">
            <span class="btn btn-icon rounded-full bg-primary-color hover:bg-[#C01555] border-primary-color text-white overflow-hidden border-0">
              <img :src="avatar" class="w-full h-full object-cover" alt="" />
            </span>
          </button>
          <div
            class="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-44 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-700"
            v-show="dropdownOpen">
            <ul class="py-2 text-start">
              <template v-if="role === 'candidate'">
                <NavBarCandidate />
              </template>
              <template v-if="role === 'employer'">
                <NavBarEmployer />
              </template>
              <li class="border-t border-gray-100 dark:border-gray-800 my-2"></li>
              <li>
                <a @click.prevent="userLogout"
                  class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-primary-color dark:hover:text-white">
                  <i data-feather="log-out" class="size-4 me-2"></i>Logout
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="menu-extras order-1 sm:order-3" @click="toggleMenu">
          <div class="menu-item">
            <a class="navbar-toggle" id="isToggle" :class="isToggled === false ? '' : 'open'">
              <div class="lines">
                <span></span> <span></span> <span></span>
              </div>
            </a>
          </div>
        </div>
      </li>
    </template>

    <template v-else>
      <li class="flex sm:inline-flex items-center gap-1 flex-nowrap justify-end py-1 sm:py-0">
        <span class="px-2 py-3 order-2 sm:order-1 mr-auto ml-1 sm:m-0">
          <DarkModeSwitcher />
        </span>

        <router-link :to="{ name: 'userLogin' }" class="text-white p-1 sm:p-2 order-3 sm:order-2 flex">
          <button
            class="text-black dark:text-white font-medium hover:text-primary-color dark:hover:text-primary-color text-xs sm:text-base">
            {{ $t('navi.user.signIn') }}
          </button>
        </router-link>

        <router-link :to="{ name: 'userRegister' }" class="order-3 hidden sm:block">
          <MagicRegisterButton />
        </router-link>

        <router-link :to="{ name: 'userRegister' }" class="order-4 block sm:hidden bg-gradient text-white text-xs font-medium px-4 py-1 rounded-md w-auto text-center shadow-custom ml-1">
          Registrieren
        </router-link>

        <div class="menu-extras order-1 sm:order-4" @click="toggleMenu">
          <div class="menu-item">
            <a class="navbar-toggle" id="isToggle" :class="isToggled === false ? '' : 'open'">
              <div class="lines">
                <span></span> <span></span> <span></span>
              </div>
            </a>
          </div>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import { globalState } from '@/events/useGlobalState';
import DarkModeSwitcher from '@/components/utility/DarkModeSwitcher.vue'
import AuthService from '@/services/auth.service'
import NavBarCandidate from '@/components/navbar/NavBarCandidate.vue'
import NavBarEmployer from '@/components/navbar/NavBarEmployer.vue'
import MagicRegisterButton from '@/components/utility/MagicRegisterButton.vue'
import { getRole } from '@/events/useGlobalState';

export default {
  props: {
    isToggled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      toggle: false,
      dropdownOpen: false,
      loggedIn: false,
      role: 'candidate',
    }
  },
  components: {
    DarkModeSwitcher, NavBarCandidate, NavBarEmployer, MagicRegisterButton
  },
  computed: {
    avatar() {
      return globalState.avatar;
    },
  },
  created() {
    const loginStatus = localStorage.getItem('loginStatus');
    if (loginStatus === 'success') {
      this.loggedIn = true
    }
    this.role = getRole();
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownToggle;
      if (dropdown && !dropdown.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
    async userLogout() {
      try {
        await AuthService.userLogout();
        this.loggedIn = false
        window.location.href = '/';
      } catch (error) {
        console.error('Error during logout', error);
      }
    },
    toggleMenu() {
      this.$emit('toggle-menu');
    }
  }
}
</script>
